if (!customElements.get('blog-post-section')) {
    // js/sections/BlogPostSection.js
    class BlogPostSection extends HTMLElement {
    constructor() {
        super();
        if (Shopify.designMode) {
        let elementToAdd = this.querySelector(".page__header");
        if (elementToAdd) {
            document.querySelector(".blog-container").previousElementSibling.remove();
            document.querySelector(".blog-container").insertAdjacentElement("beforebegin", elementToAdd);
        }
        }
    }
    };

    customElements.define('blog-post-section', BlogPostSection);
}